import { Booking, Summary } from "../../state/models";
import { isAgent } from "./pushEvent";

declare function uet_report_conversion(revenue: number, currency: string): void;

export function pushRevenueToUet({booking, summary}: {booking: Booking, summary: Summary}) {

  if(isAgent()) return;
  
  if(!booking || booking.bookingStatus !== 'Confirmed') return;
  if(!summary || !Array.isArray(summary.segments) || summary.bookingTotal < 0) return;

  uet_report_conversion(summary.bookingTotal, summary.currencyCode);
}